<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col cols="4">
              <h2 class="mt-1">
                Generación: <strong>{{ description }}</strong>
              </h2>
              <h4>Total de becarios: {{ total }}</h4>
            </b-col>
            <b-col cols="5" />
            <b-col cols="3">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                block
                variant="relief-primary"
                :disabled="isEdit"
                @click="exportGeneration"
              >
                <b-spinner
                  v-if="downloading"
                  class="mr-1"
                  small
                />
                <feather-icon
                  v-if="!downloading"
                  size="18"
                  icon="DownloadIcon"
                  class="mr-1"
                />
                exportar generación
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="12">
        <b-card>
          <b-tabs>
            <b-tab
              title="Formación Inicial"
              lazy
            >
              <formacion-inicial
                :data="becarios"
                @update-list="fetchBecariosByGeneration"
              />
            </b-tab>
            <b-tab
              title="Competencias Básicas"
              lazy
            >
              <competencias-basicas
                :data="becarios"
                @update-list="fetchBecariosByGeneration"
              />
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BRow,
  BSpinner,
  BTabs,
  BTab,
} from 'bootstrap-vue'

import _ from 'lodash'
import { maska } from 'maska'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'
import BecariosService from '@/services/BecariosService'
import GeneracionesService from '@/services/GeneracionesService'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import FormacionInicial from './components/FormacionInicial.vue'
import CompetenciasBasicas from './components/CompetenciasBasicas.vue'

export default {
  directives: {
    Ripple,
    maska,
  },
  components: {
    BButton,
    BCard,
    BCol,
    BRow,
    BSpinner,
    BTabs,
    BTab,
    FormacionInicial,
    CompetenciasBasicas,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    rulesInput: {
      numeral: true,
      numeralDecimalMark: '.',
      numeralDecimalScale: 2,
      numeralIntegerScale: 2,
      numeralPositiveOnly: true,
      stripLeadingZeroes: false,
    },
    isEdit: false,
    downloading: false,
    isLoading: true,
    becarios: [],
    total: 0,
    columns: [
      { label: 'id', field: 'id' },
      { label: 'CURP', field: 'prebecario.curp' },
      {
        label: 'Formación Inicial',
        field: 'formacionInicial',
        tdClass: 'text-center',
      },
      {
        label: 'Evaluación Academica',
        field: 'evaluacionAcademica',
        tdClass: 'text-center',
      },
      {
        label: 'Competencias Básicas',
        field: 'competenciasBasicas',
        tdClass: 'text-center',
      },
      {
        label: 'Evaluación Competencias Básicas',
        field: 'evaluacionCompetenciasBasicas',
        tdClass: 'text-center',
      },
      {
        label: 'Enviar a Adscripción',
        field: 'enviarAdscripcion',
        tdClass: 'text-center',
      },
      { label: 'Acciones', field: 'action', sortable: false },
    ],
  }),
  computed: {
    getStatus() {
      return status => (status ? 'CheckSquareIcon' : 'XSquareIcon')
    },
    getColor() {
      return status => (status ? 'success' : 'danger')
    },
    getEvaluation() {
      return evaluation => evaluation || 'Sin evaluación'
    },
    setTextButton() {
      return edit => (!edit ? 'editar generación' : 'finalizar edición')
    },
    statusAdscripcion() {
      return status => (!status ? 'enviar adscripcion' : 'en adscripcion')
    },
    getUltimaCompetencia() {
      return null
    },
  },
  watch: {
    id: function funId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchBecariosByGeneration()
        this.isEdit = false
      }
    },
  },
  mounted() {
    this.fetchBecariosByGeneration()
  },
  created() {
    this.test = _.debounce(this.test, 1000)
  },
  methods: {
    test(id, data, value) {
      if (value && value !== '' && value >= 0 && value <= 10) {
        this.updateDataBecario(id, data)
        // this.$toast({
        //   component: ToastificationContent,
        //   props: {
        //     title: 'Ok!',
        //     icon: 'SmileIcon',
        //     text: 'Datos Guardados ',
        //     variant: 'success',
        //   },
        // })
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            text: 'Calificacion no valida',
            variant: 'danger',
          },
        })
      }
    },
    // tabActive(tabSelected) {
    // },
    fetchBecariosByGeneration() {
      this.isLoading = true
      BecariosService.getBecariosByGeneracion(this.id)
        .then(response => {
          this.becarios = response.data.results
          this.total = this.becarios.length
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    editGeneration() {
      const vm = this
      vm.isEdit = !vm.isEdit
      if (!vm.isEdit) {
        this.fetchBecariosByGeneration()
      }
    },
    updateDataBecario(id, data) {
      BecariosService.setData(id, data)
    },
    exportGeneration() {
      this.downloading = true
      GeneracionesService.exportData({
        generacion: this.id,
      })
        .then(response => {
          if (response.status === 200) {
            const blob = new Blob([response.data], {
              type: response.headers['content-type'],
            })
            const date = moment().format('l')
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = `generacion-${this.description}-${date}.xlsx`
            link.click()
          }
        })
        .finally(() => {
          this.downloading = false
        })
    },
  },
}
</script>

<style scope lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
